import React from "react";
import { PublicLayoutComponent } from "../components";
import "../../../assets/theme/globalStyle.css";

export const PublicLayout = () => {
  return <PublicLayoutComponent  />;
};